import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e9eaeb;
  margin: 24px 0;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const AssetCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AssetLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
`;

export const AssetSymbol = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #1a1a1a;
  line-height: 1.2;
`;

export const AssetName = styled.div`
  font-size: 12px;
  color: #666;
  line-height: 1.2;
  margin-top: 2px;
`;

export const PriceCell = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #1a1a1a;
`;

export const PerformanceCell = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;

  .performance-pill {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px 2px 6px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    width: fit-content;
    border: 1px solid transparent;

    &.gain {
      background-color: #f2fbf4;
      color: #276e38;
      border-color: #c5edce;

      svg {
        fill: #3daa57;
      }
    }

    &.loss {
      background-color: #ffeaea;
      color: #d32f2f;

      svg {
        fill: #d32f2f;
      }
    }
  }

  .performance-period {
    font-size: 14px;
    color: #535862;
    font-weight: 400;
  }
`;

export const IndustryCell = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 400;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #fff;
  flex-shrink: 0;
  border: 1px solid #d5d7da;
  box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  img {
    width: 20px;
    height: 20px;
  }
`;

export const SummarySection = styled.div``;

export const HoldingsSection = styled.div`
  margin-top: 24px;
`;

export const HoldingsTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Geist", sans-serif;

  img {
    width: 16px;
    height: 16px;
  }
`;
